/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto';
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDto(value) {
    if (!('Account' in value) || value['Account'] === undefined)
        return false;
    if (!('Track' in value) || value['Track'] === undefined)
        return false;
    if (!('Features' in value) || value['Features'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Account': FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSON(json['account']),
        'Track': FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON(json['track']),
        'Features': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON(json['features']),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'account': FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSON(value['Account']),
        'track': FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON(value['Track']),
        'features': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON(value['Features']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDto.js.map